<template>
  <div class="modal-header">
    <slot />
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({});
</script>
